"use client"

import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function SearchIcon({ className }: Props) {
  const { t } = useLingui()

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="search-icon"
      className={className}
    >
      <title>{t`Search Icon`}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 11C6.25 8.37665 8.37665 6.25 11 6.25C13.6234 6.25 15.75 8.37665 15.75 11C15.75 13.6234 13.6234 15.75 11 15.75C8.37665 15.75 6.25 13.6234 6.25 11ZM11 4.75C7.54822 4.75 4.75 7.54822 4.75 11C4.75 14.4518 7.54822 17.25 11 17.25C12.4616 17.25 13.8059 16.7483 14.8703 15.9078C14.8985 15.9512 14.9316 15.9923 14.9697 16.0303L17.9697 19.0303C18.2626 19.3232 18.7374 19.3232 19.0303 19.0303C19.3232 18.7374 19.3232 18.2626 19.0303 17.9697L16.0303 14.9697C15.9923 14.9316 15.9512 14.8985 15.9078 14.8703C16.7483 13.8059 17.25 12.4616 17.25 11C17.25 7.54822 14.4518 4.75 11 4.75Z"
        fill="currentColor"
      />
    </svg>
  )
}
